module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/personality-relax-bg-shenzhen.65abd0f8.jpg";